export enum BriefingsApiErrorEnum {
    tooLateToCancel = 'BRIEFING-001', // The briefing or alert cannot be cancelled as it is too late
    nameDuplicate = 'BRIEFING-002', // The briefing's name is already used
    invalidEmail = 'BRIEFING-006', // The briefing contains an invalid email
    mailingListNameDuplicate = 'MAILING-LIST-001', // The mailing list's name is already used
    recipientEmailDuplicate = 'RECIPIENT-001', // The recipient's email is already used
    alreadySent = 'BRIEFING-010' // The briefing has been scheduled to send
}
